module.exports = __webpack_public_path__ + "static/media/winno-tabs.d8d70146.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingFlow/assets/winno-tabs.png
// module id = 934
// module chunks = 0